import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-user-companies',
  imports: [RouterModule],
  templateUrl: './user-companies.html',
  styleUrl: './user-companies.scss',
})
export class UserCompanies {}
